/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
import{ObservationHandle as e}from"./ObservationHandle.js";class r{constructor(){this._observers=new Set}observe(r){return new e(this._observers.add(r),r)}notify(){const e=this._observers,r=this._observers.size,s=new Array(r);let o=0;for(const t of e)s[o++]=t;for(let t=0;t<r;t++)s[t].notify()}}export{r as SimpleObservable};
